<template>
  <div
    class="address-cell"
    v-if="name || computedPlaceHasValues || (places && places.length > 0)"
  >
    <p>{{ name }}</p>
    <template v-if="computedPlace">
      <p>
        {{ streetAddress }}
      </p>
      <p>
        {{ computedPlace.cityStateZip }}
        <a
          class="ml-1 text-red hover-bold"
          :href="generateGoogleMapsUrl(computedPlace)"
        >
          <i class="fal fa-map-marker-alt"></i>
        </a>
      </p>
    </template>
    <template v-else>
      <div :key="`place_${i}`" v-for="(place, i) in places">
        <p>{{ place.address_1 }}</p>
        <p>
          {{ place.cityStateZip }}
          <a
            class="ml-1 text-red hover-bold"
            :href="generateGoogleMapsUrl(place)"
          >
            <i class="fal fa-map-marker-alt"></i>
          </a>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { Place } from "../../../models/Place";

export default {
  name: "AddressCell",
  props: {
    name: String,
    place: Place,
    primary_place: Place,
    places: Array,
    address_1: String,
    address_2: String,
    city: String,
    state: String,
    zip: String
  },
  computed: {
    computedPlace() {
      if (this.place) {
        return this.place;
      }
      if (this.primary_place) {
        return this.primary_place;
      }
      if (this.address_1 && this.city && this.state && this.zip) {
        return new Place({
          address_1: this.address_1,
          address_2: this.address_2,
          city: this.city,
          state: this.state,
          zip: this.zip
        });
      }
      return null;
    },
    computedPlaceHasValues() {
      return (
        this.computedPlace && Object.values(this.computedPlace).some(v => !!v)
      );
    },
    streetAddress() {
      return this.computedPlace.address_1 && this.computedPlace.address_2
        ? `${this.computedPlace.address_1}, ${this.computedPlace.address_2}`
        : this.computedPlace.address_1;
    }
  }
};
</script>

<style scoped></style>
